import { KKCAppeal, KKCAppealColdInfo } from '@/interface/KKC/appeal';
import { BankTypeEnum } from '@/interface/KKC/withdrawal';
import { creditApply, OtherInfoType } from '@/pages/KKC/credit/subpages/creditprocess/interface';
import { CreditState } from '@/pages/KKC/loading/ValidateLogic/interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CommonState {
  creditApply: creditApply;
  auditReason: string; // 账单准入失败的结果信息
  bankType: BankTypeEnum | null;
  otherInfo: OtherInfoType | null;
  kkcAppealInfo: KKCAppeal | null;
  kkcAppealColdInfo: KKCAppealColdInfo | null;
  preState: CreditState | null; // 上一个状态
  stateHasChange: boolean;
}

const initialState: CommonState = {
  creditApply: {
    id: '',
  },
  auditReason: '',
  bankType: null,
  otherInfo: null,
  kkcAppealInfo: null,
  kkcAppealColdInfo: null,
  preState: null,
  stateHasChange: false,
};

const creditApplySlice = createSlice({
  name: 'creditApply',
  initialState,
  reducers: {
    setCreditApply(state: any, action: PayloadAction<{ creditApply: creditApply }>) {
      state.creditApply = action.payload.creditApply;
    },
    setAdmittanceAuditReson(state: CommonState, action: PayloadAction<{ auditReason: string }>) {
      state.auditReason = action.payload.auditReason;
    },
    //       Vhkstore.dispatch(setAdmittanceAuditReson({ auditReason: '' }));
    // Vhkstore.getState().creditApplyReducer.auditReason
    setBankcontent(state: CommonState, action: PayloadAction<{ bankType: BankTypeEnum | null }>) {
      state.bankType = action.payload.bankType;
    },
    clearBankcontent(state: CommonState) {
      state.bankType = null;
    },
    setOtherInfo(state: CommonState, action: PayloadAction<{ otherInfo: OtherInfoType | null }>) {
      state.otherInfo = action.payload.otherInfo;
    },
    setKKCAppeal(state: CommonState, action: PayloadAction<KKCAppeal>) {
      state.kkcAppealInfo = action.payload;
    },
    setKKCAppealColdInfo(state: CommonState, action: PayloadAction<KKCAppealColdInfo>) {
      state.kkcAppealColdInfo = action.payload;
    },
    setCreditStateHasChange(state: CommonState, action: PayloadAction<boolean>) {
      state.stateHasChange = action.payload;
    },
    setPreState(state: CommonState, action: PayloadAction<CreditState>) {
      state.preState = action.payload;
    },
  },
  extraReducers: () => {
    // 异步action成功的reducer执行
  },
});

const {
  setCreditApply,
  setAdmittanceAuditReson,
  setBankcontent,
  setOtherInfo,
  setKKCAppeal,
  setKKCAppealColdInfo,
  setCreditStateHasChange,
  setPreState,
} = creditApplySlice.actions;

export {
  setAdmittanceAuditReson,
  setBankcontent,
  setCreditApply,
  setOtherInfo,
  setKKCAppeal,
  setKKCAppealColdInfo,
  setCreditStateHasChange,
  setPreState,
};

export default creditApplySlice.reducer;
